export default "/_next/static/images/863480dd53c06515c71aa0fb46ff63c2.png";